(function () {
  var OBSERVER_OPTIONS = { threshold: 0.12, rootMargin: '0px 0px -5% 0px' };

  function pauseExternalVideo(container) {
    if (!container) return;
    if (window.Alpine && Alpine.store && typeof Alpine.store('xVideo') !== 'undefined') {
      try {
        Alpine.store('xVideo').pause(container);
        return;
      } catch (e) {}
    }
    var iframe = container.querySelector('iframe');
    if (iframe && iframe.contentWindow) {
      var host = iframe.getAttribute('host');
      var cmd =
        host === 'youtube'
          ? { event: 'command', func: 'pauseVideo' }
          : { method: 'pause', value: 'true' };
      try {
        iframe.contentWindow.postMessage(JSON.stringify(cmd), '*');
      } catch (err) {}
    }
  }

  function pauseMediaIn(section) {
    section.querySelectorAll('video').forEach(function (video) {
      try {
        video.pause();
      } catch (e) {}
    });

    section.querySelectorAll('.external-video, .video-hero, .contain-video').forEach(pauseExternalVideo);

    section.querySelectorAll('[data-iia-video-wrap], [data-dyl-video-wrap]').forEach(function (wrap) {
      wrap.classList.remove('is-playing');
    });
  }

  function sectionHasVideo(section) {
    return !!section.querySelector(
      'video, .video-hero, .external-video, [data-iia-video-wrap], [data-dyl-video-wrap], [data-gcp-video-wrap]'
    );
  }

  function initSection(section) {
    if (!section || section.dataset.sectionVideoVisibility === '1') return;
    if (!sectionHasVideo(section)) return;
    if (!('IntersectionObserver' in window)) return;

    section.dataset.sectionVideoVisibility = '1';

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) pauseMediaIn(section);
      });
    }, OBSERVER_OPTIONS);

    observer.observe(section);
  }

  function boot(scope) {
    var root = scope || document;
    if (root.classList && root.classList.contains('shopify-section')) {
      initSection(root);
      return;
    }
    root.querySelectorAll('.shopify-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    delete e.target.dataset.sectionVideoVisibility;
    boot(e.target);
  });
})();
